import React, { FC } from 'react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { PassengersPageId } from '../../../../app/pages/domain/constants/PageId';
import { ParkingPageId } from '../../../domain/pages/ParkingPageId';
import { AvailabilityResults } from '../../booking-steps/availability';
import { ParkingSearch } from '../../search/ParkingSearch';
import { BookingPageLayout } from '../shared/BookingPageLayout';

export const FullAmendAvailabilityPage: FC = () => {
	const { t } = useTranslation();
	const parentUrl = useUrlForPageId(PassengersPageId.Parking);
	const extrasUrl = useUrlForPageId(ParkingPageId.FullAmendBookingExtras);
	const paymentUrl = useUrlForPageId(ParkingPageId.FullAmendBookingPayment);

	return (
		<BookingPageLayout
			parentTitle={t('web_parking_modify_availability_results_back_button')}
			parentUrl={parentUrl}
			theme="green-blue"
			title={t('web_parking_modify_availability_results_header')}
		>
			<ParkingSearch
				startTimeMinimumOffsetInSeconds={0}
				customSubmitButtonText={t('web_parking_availability_update_button')}
				shouldStayOnPage
				isAmendFlow
			/>
			<AvailabilityResults extrasUrl={extrasUrl} fallbackUrl={paymentUrl} />
		</BookingPageLayout>
	);
};
